import React from 'react';
import { CartItem } from './cart-items/cart-item.jsx';

export const UpsellItems = ({ items, onAddItem }) => (
  <div className="cart-popup__upsell-items">
    <p className="cart-popup__upsell-items-title">Customers often add</p>
    {items.map((item) => (
      <CartItem
        key={item.variantId}
        flavor={item.flavor}
        variantTitle={item.variantTitle}
        productTitle={item.productTitle}
        finalPrice={item.finalPrice}
        image={item.image}
        onAddItem={() => onAddItem(item.variantId)}
      />
    ))}
  </div>
);
